import React from 'react';
import { Box, Button, Card, Paragraph } from 'bumbag';
import _get from 'lodash/get';

import { LandingPage } from '@medipass/react-core';
import { Link as RouterLink, withRouter } from '@medipass/react-core/router';
import sdk from '@medipass/web-sdk';

import PaymentMethodForm from 'legacy/components/account/payment-methods/PaymentMethodForm';
import WithAuthentication from 'legacy/components/WithAuthentication';
type Props = {
  history: (...args: Array<any>) => any;
};

class CreatePaymentMethod extends React.PureComponent<Props> {
  handleAddPaymentMethod = async ({ nonce, source }: { nonce: string; source: string }) => {
    const { history } = this.props;

    const accountId = _get(sdk, 'account._id');

    const paymentMethod = await sdk.payments.createAccountPaymentMethod(accountId, nonce, source);
    // @ts-expect-error TS(2339): Property 'push' does not exist on type '(...args: ... Remove this comment to see the full error message
    history.push('/account/onboarding/create-health-fund-account/');
    return paymentMethod;
  };
  render = () => (
    <WithAuthentication>
      <LandingPage
        description={<Paragraph>Add a payment card to enable payment of any out of pocket services.</Paragraph>}
        // @ts-expect-error
        isLight
        title="Add payment card"
      >
        {/* @ts-expect-error TS(2322): Type '"auto"' is not assignable to type 'Flexible<... Remove this comment to see the full error message */}
        <Box width="auto">
          <Card className="content">
            <PaymentMethodForm
              title="Add a payment card"
              isMobileTitle={false}
              isSubmitButtonInsideSection
              onSubmit={this.handleAddPaymentMethod}
              // @ts-expect-error TS(7031): Binding element 'isLoading' implicitly has an 'any... Remove this comment to see the full error message
              submitButtonRenderer={({ isLoading }) => (
                <Box textAlign="center">
                  <Button palette="secondary" isLoading={isLoading} size="medium" width="100%" type="submit">
                    CONTINUE
                  </Button>
                  <Button
                    // @ts-expect-error

                    use={RouterLink}
                    to="/account/onboarding/create-health-fund-account/"
                    palette="secondary"
                    marginTop="major-1"
                    variant="ghost"
                  >
                    I{"'"}ll do this later
                  </Button>
                </Box>
              )}
            />
          </Card>
        </Box>
      </LandingPage>
    </WithAuthentication>
  );
}

export default withRouter(CreatePaymentMethod);
